<!-- <div class="flex flex-col gap-4"> -->
<!-- <h1 class="text-2xl font-bold text-[#C42727]" i18n="@@editPharmacyInformation">Edit Pharmacy Information</h1> -->
@if (pharmacyData()) {
  <!-- <app-edit-pharmacy-form [pharmacyData]="pharmacyData()!" /> -->
  <app-new-request type="edit" [pharmacyData]="pharmacyData()!" />
}
<!-- </div> -->
